module.exports = __webpack_public_path__ + "img/dp-ld-zy1.8583cad7.png";